












































import { format } from '~/utils/date'
import { defineComponent, computed, ref } from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS } from '~/store/modules/shared/user/state'
import { useI18n } from '~/compositions/i18n'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { useAppConfirmationModal } from '~/compositions/app-confirmation-modal'
import { useDeps } from '~/compositions/dependency-container'
import ClassifiedService from '~/services/classified/ClassifiedService'
import useClassifiedAction from '~/compositions/useClassifiedAction'
import { useSnackbar } from '~/compositions/snackbar'
import { useRouter } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CConfirmationModal, CShimmer },
  props: {
    classifiedId: {
      type: [String, Number],
      required: true
    },
    classifiedDeletedDate: {
      type: [String, Number],
      default: ''
    },
    classifiedIsRemoved: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { getters: userGetters } = useNamespacedStore(USER_NS)
    const { t, locale } = useI18n()
    const confirm = useAppConfirmationModal()
    const [classifiedService] = useDeps(ClassifiedService)
    const { handleActionError } = useClassifiedAction()
    const snackbar = useSnackbar()
    const router = useRouter()

    const isLoading = ref(false)

    const userIsAdmin = computed(() => userGetters('isAdmin'))

    const userIsSingle = computed(() => userGetters('isSingle'))

    const formattedClassifiedDeletedDate = computed(() =>
      format(props.classifiedDeletedDate, 'PPpp', {
        locale
      })
    )

    function onRestoreButtonClick() {
      confirm.show({
        confirmButtonText: t('restore'),
        variant: 'secondary',
        title: t('restore'),
        text: t('are you sure you want to restore this classified?'),
        onConfirm: async () => {
          isLoading.value = true
          try {
            const data = await classifiedService.restore(props.classifiedId)

            snackbar.success(data.message)
            emit('restore', data)
          } catch (err) {
            handleActionError(err)
          } finally {
            isLoading.value = false
          }
        }
      })
    }

    function onRemoveButtonClick() {
      confirm.show({
        confirmButtonText: t('remove permanently'),
        variant: 'danger',
        title: t('permanent removal'),
        text: t('are_you_sure_you_want_to_remove_this_classified'),
        onConfirm: async () => {
          isLoading.value = true
          try {
            const data = await classifiedService.remove(props.classifiedId)

            snackbar.success(data.message)
            if (userIsSingle.value) {
              // The single user just deleted his "account" by perma deleting
              // their single classified, so log them out
              router.push({ name: '__logout' })
              return
            }

            emit('remove', data)
          } catch (err) {
            handleActionError(err)
          } finally {
            isLoading.value = false
          }
        }
      })
    }

    return {
      isLoading,
      userIsAdmin,
      formattedClassifiedDeletedDate,
      onRestoreButtonClick,
      onRemoveButtonClick
    }
  }
})
